"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _reactJss = require("react-jss");

//eslint-disable-next-line
//eslint-disable-next-line
var LockedstylesWithProps = function LockedstylesWithProps(props) {
  return {};
}; //eslint-disable-next-line


var Lockedstyles = {};
var styles = (0, _reactJss.createUseStyles)(function (theme) {
  return {};
});
/**
 * Component Description
 */

var FormTextAreaComponent = /*#__PURE__*/_react["default"].forwardRef(function FormTextAreaComponent(props, ref) {
  /****************************** PROPS AND JSS CLASSES *********************/
  var InputRef = props.InputRef,
      TextAreaInputRef = props.TextAreaInputRef,
      currentValue = props.currentValue,
      placeHolder = props.placeHolder,
      InputClass = props.InputClass,
      disabled = props.disabled,
      readOnly = props.readOnly,
      RowsToDisplay = props.RowsToDisplay,
      MaxRows = props.MaxRows,
      style = props.style,
      name = props.name,
      InputOnBlur = props.InputOnBlur,
      InputOnFocus = props.InputOnFocus,
      InputOnChange = props.InputOnChange;
  var theme = (0, _reactJss.useTheme)(); //eslint-disable-next-line

  var classes = styles((0, _extends2["default"])({}, props, {
    theme: theme
  }));
  /****************************** PROPS AND JSS CLASSES *********************/

  /****************************** REFS *********************/

  var FakeTextArea = (0, _react.useRef)(null);
  /****************************** REFS *********************/

  /****************************** STATE *********************/

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      LineHeight = _useState2[0],
      setLineHeight = _useState2[1];

  var _useState3 = (0, _react.useState)({
    height: null,
    overflow: 'hidden'
  }),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      TextAreaStyle = _useState4[0],
      setTextAreaStyle = _useState4[1];
  /****************************** STATE *********************/

  /****************************** EFFECT *********************/
  //WHEN COMPONENT LOADS
  // useEffect(() => {
  //     //Execute your code here
  // }, []);
  //CALCULATING THE LINEHEIGHT FOR THE MULTILINE


  (0, _react.useEffect)(function () {
    if (InputRef.current && TextAreaInputRef.current) {
      //1. Calculate the initial height with the fake input
      var FakeInputHeight = TextAreaInputRef.current.getBoundingClientRect().height;
      setLineHeight("".concat(FakeInputHeight, "px"));
      setTextAreaStyle({
        height: "".concat(FakeInputHeight, "px"),
        overflow: 'hidden'
      });
    }
  }, [InputRef, TextAreaInputRef]);
  (0, _react.useEffect)(function () {
    if (currentValue) {
      //Calculate only if the input is not empty
      if (InputRef.current && TextAreaInputRef.current && FakeTextArea.current) {
        var TextAreaRealHeight = FakeTextArea.current.scrollHeight + 4;

        if (TextAreaRealHeight > parseInt(LineHeight)) {
          //Means that we have mutiple lines -> Calculate number of lines
          var CurrentRows = Math.round(TextAreaRealHeight / parseInt(LineHeight));

          if (CurrentRows < MaxRows) {
            var NewHeight = CurrentRows * parseInt(LineHeight);
            setTextAreaStyle({
              height: "".concat(NewHeight, "px"),
              overflow: 'hidden'
            });
          } else {
            var _NewHeight = parseInt(MaxRows) * parseInt(LineHeight);

            setTextAreaStyle({
              height: "".concat(_NewHeight, "px"),
              overflow: 'hidden'
            });
          }
        } else {
          //Display the requested number of rows
          var _NewHeight2 = parseInt(RowsToDisplay) * parseInt(LineHeight);

          setTextAreaStyle({
            height: "".concat(_NewHeight2, "px"),
            overflow: 'hidden'
          });
        }
      }
    }
  }, [currentValue, InputRef, TextAreaInputRef, FakeTextArea, LineHeight, MaxRows, RowsToDisplay]);
  /****************************** EFFECT *********************/

  /****************************** FUNCTIONS *********************/
  //CALCULATE THE LINE HEIGHT WHEN MOUNTING
  //UPDATE THE TEXTAREA HEIGHT WHEN CHANGING

  /****************************** FUNCTIONS *********************/

  /****************************** RENDER *********************/

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("input", {
    ref: TextAreaInputRef,
    value: currentValue,
    style: (0, _extends2["default"])({}, style, {
      display: LineHeight ? 'none' : 'box'
    }),
    className: InputClass
  }), /*#__PURE__*/_react["default"].createElement("textarea", {
    ref: FakeTextArea,
    value: currentValue,
    className: InputClass,
    rows: RowsToDisplay,
    style: (0, _extends2["default"])({}, style, {
      marginBottom: '0px',
      padding: '0px',
      height: '0px',
      visibility: 'hidden'
    })
  }), /*#__PURE__*/_react["default"].createElement("textarea", {
    ref: InputRef,
    value: currentValue,
    autoComplete: "off",
    placeholder: placeHolder,
    className: InputClass,
    disabled: disabled,
    readOnly: readOnly,
    rows: RowsToDisplay,
    style: (0, _extends2["default"])({}, style, {
      height: TextAreaStyle.height
    }),
    name: name,
    onBlur: InputOnBlur,
    onFocus: InputOnFocus,
    onChange: InputOnChange
  }));
  /****************************** RENDER *********************/
});

FormTextAreaComponent.defaultProps = {
  MyProp: null
};
process.env.NODE_ENV !== "production" ? FormTextAreaComponent.propTypes = {
  /**
   * MyProp :
   */
  MyProp: _propTypes["default"].string
} : void 0;
var _default = FormTextAreaComponent;
exports["default"] = _default;